import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subPrice',
  standalone: true,
})
export class SubPricePipe implements PipeTransform {
  transform(value: number | null): string {
    const price = Number(value);
    if (isNaN(price) || price === 0) {
      return 'Free';
    }

    return `$${price}/mth`;
  }
}
